import { WFPUsersSection } from './wfp-users-section';
import { ExternalUsersSection } from './external-users-section';

const LoginPage = () => {
  return (
    <div className="h-full bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8">
        <WFPUsersSection />
        <ExternalUsersSection />
      </div>
    </div>
  );
};

export default LoginPage;
